var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-object",class:{ 'media-object--placeholder': _vm.isPlaceholder }},[(!!_vm.$slots.image)?_vm._t("image"):_c('div',{staticClass:"media-object__image",style:(_vm.getImageStyle)}),_vm._v(" "),_c('div',{staticClass:"media-object__content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }